/**
 * Live Opportunity Feed Component
 */


interface Opportunity {
  id: number;
  ticker: string;
  opportunity_type: string;
  confidence: number;
  trigger_reason: string;
  priority: string;
  detected_at: string;
}

interface Props {
  opportunities: Opportunity[];
  realtime: boolean;
}

export function LiveOpportunityFeed({ opportunities }: Props) {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">🚨 Opportunities</h2>
      </div>
      
      {opportunities.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <p className="text-lg">No opportunities detected yet.</p>
          <p className="text-sm mt-2">System is monitoring your watchlist...</p>
        </div>
      ) : (
        <div className="opportunities-list">
          {opportunities.map(opp => (
            <div 
              key={opp.id} 
              className={`opportunity-card priority-${opp.priority}`}
            >
              <div className="opp-header">
                <span className="ticker">{opp.ticker}</span>
                <span className="confidence">{(opp.confidence * 100).toFixed(0)}%</span>
              </div>
              <div className="opp-type">{opp.opportunity_type.replace('_', ' ')}</div>
              <div className="opp-reason">{opp.trigger_reason}</div>
              <div className="opp-footer">
                <span className="priority">{opp.priority.toUpperCase()}</span>
                <span className="timestamp">
                  {new Date(opp.detected_at).toLocaleTimeString()}
                </span>
              </div>
              <button className="analyze-btn">Analyze Now</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

